module.exports = __webpack_public_path__ + "static/media/headerLogo.cd75ac13.png";